import React from 'react';
export function FicheTPPanel() {
  return <div className="bg-white shadow-2xl overflow-hidden flex flex-col" data-id="element-53">
      <div className="bg-primary-dark p-8 flex justify-between items-center shrink-0" data-id="element-54">
        <div data-id="element-55">
          <p className="text-brand-orange font-bold text-sm tracking-wider mb-1" data-id="element-56">
            FICHE FORMATION
          </p>
          <h2 className="text-3xl font-heading font-extrabold text-white" data-id="element-57">
            TP CONSEILLER DE VENTE
          </h2>
        </div>
        <div className="bg-brand-orange text-white font-bold px-6 py-2" data-id="element-58">
          Niveau 4 • RNCP37098 • 2026–2027
        </div>
      </div>
      <div className="flex-1 flex p-8 gap-12" data-id="element-59">
        <div className="w-[45%] flex flex-col" data-id="element-60">
          <h3 className="text-2xl font-heading font-extrabold text-primary-dark mb-4 leading-tight" data-id="element-61">
            FORMER UN VENDEUR CONSEIL OPÉRATIONNEL EN OMNICANAL
          </h3>
          <p className="text-primary-dark font-bold mb-6" data-id="element-62">
            Le parcours prépare à conseiller des clients, animer l'offre
            commerciale, traiter les flux marchands et contribuer aux résultats
            d'une unité marchande.
          </p>

          <h4 className="text-brand-orange font-bold mb-2" data-id="element-63">PUBLIC VISÉ</h4>
          <p className="text-primary-dark text-sm mb-6" data-id="element-64">
            Candidats souhaitant exercer dans la vente, le conseil client, la
            relation omnicanale, le commerce de proximité, la grande
            distribution ou les magasins spécialisés.
          </p>

          <h4 className="text-brand-orange font-bold mb-2" data-id="element-65">PRÉREQUIS</h4>
          <p className="text-primary-dark text-sm mb-6" data-id="element-66">
            Compréhension orale et écrite du français, bases de calcul
            commercial, aisance relationnelle, projet professionnel validé après
            entretien et positionnement.
          </p>

          <div className="bg-primary-dark text-white p-6 mt-auto" data-id="element-67">
            <h4 className="text-brand-orange font-bold mb-2" data-id="element-68">
              OBJECTIFS PÉDAGOGIQUES MESURABLES
            </h4>
            <p className="text-sm font-medium" data-id="element-69">
              À l'issue du parcours, l'apprenant sera capable de réaliser une
              veille commerciale, traiter une réception et une opération
              promotionnelle, conduire un entretien de vente, gérer une
              réclamation, suivre ses ventes et proposer des actions
              d'amélioration à partir d'indicateurs.
            </p>
          </div>
        </div>
        <div className="w-[55%] flex flex-col gap-4 text-sm" data-id="element-70">
          <div className="flex gap-8 border-b border-primary/20 pb-4" data-id="element-71">
            <div className="w-1/2" data-id="element-72">
              <h4 className="font-bold text-primary-dark mb-1" data-id="element-73">DURÉE</h4>
              <p className="text-primary-dark" data-id="element-74">
                Parcours en alternance sur 1 an, session 2026–2027.
              </p>
            </div>
            <div className="w-1/2" data-id="element-75">
              <h4 className="font-bold text-primary-dark mb-1" data-id="element-76">RYTHME</h4>
              <p className="text-primary-dark" data-id="element-77">
                4 jours en entreprise et 1 jour en centre de formation
                (mercredi)
              </p>
            </div>
          </div>
          <div className="flex gap-8 border-b border-primary/20 pb-4" data-id="element-78">
            <div className="w-1/2" data-id="element-79">
              <h4 className="font-bold text-primary-dark mb-1" data-id="element-80">RENTRÉE</h4>
              <p className="text-primary-dark" data-id="element-81">
                25 septembre 2026, sous réserve de places disponibles.
              </p>
            </div>
            <div className="w-1/2" data-id="element-82">
              <h4 className="font-bold text-primary-dark mb-1" data-id="element-83">ACCÈS</h4>
              <p className="text-primary-dark" data-id="element-84">
                Candidature, entretien, positionnement, validation du projet et
                contrat d'apprentissage.
              </p>
            </div>
          </div>
          <div className="flex gap-8 border-b border-primary/20 pb-4" data-id="element-85">
            <div className="w-1/2" data-id="element-86">
              <h4 className="font-bold text-primary-dark mb-1" data-id="element-87">
                DÉLAI D'ACCÈS
              </h4>
              <p className="text-primary-dark" data-id="element-88">
                Selon calendrier, date de candidature, places disponibles et
                contractualisation.
              </p>
            </div>
            <div className="w-1/2" data-id="element-89">
              <h4 className="font-bold text-primary-dark mb-1" data-id="element-90">
                TARIF APPRENTI
              </h4>
              <p className="text-primary-dark" data-id="element-91">
                0 € pour l'apprenti sous contrat ; financement selon prise en
                charge OPCO.
              </p>
            </div>
          </div>
          <div className="border-b border-brand-orange pb-4" data-id="element-92">
            <h4 className="font-bold text-primary-dark mb-1" data-id="element-93">
              MÉTHODES MOBILISÉES
            </h4>
            <p className="text-primary-dark" data-id="element-94">
              Apports ciblés, ateliers produits, cas de réception,
              merchandising, jeux de rôle vente/réclamation, tableau de bord,
              productions professionnelles et accompagnement individualisé.
            </p>
          </div>
          <div className="flex gap-8 border-b border-primary/20 pb-4" data-id="element-95">
            <div className="w-1/2" data-id="element-96">
              <h4 className="font-bold text-primary-dark mb-1" data-id="element-97">
                ÉVALUATIONS EN FORMATION
              </h4>
              <p className="text-primary-dark" data-id="element-98">
                Quiz, mises en situation, études de cas, fiches produits,
                diaporama, entretiens simulés et dossier professionnel.
              </p>
            </div>
            <div className="w-1/2" data-id="element-99">
              <h4 className="font-bold text-primary-dark mb-1" data-id="element-100">
                ÉPREUVE CERTIFICATIVE
              </h4>
              <p className="text-primary-dark" data-id="element-101">
                Mise en situation 2 h, entretien technique 30 min, productions 1
                h 10, entretien final 15 min.
              </p>
            </div>
          </div>
          <div className="flex gap-8" data-id="element-102">
            <div className="w-1/2" data-id="element-103">
              <h4 className="font-bold text-primary-dark mb-1" data-id="element-104">
                ACCESSIBILITÉ PSH
              </h4>
              <p className="text-primary-dark" data-id="element-105">
                Étude individualisée des besoins. Référent handicap :
                samir@zilleniumalternance.fr.
              </p>
            </div>
            <div className="w-1/2" data-id="element-106">
              <h4 className="font-bold text-primary-dark mb-1" data-id="element-107">CONTACT</h4>
              <p className="text-primary-dark" data-id="element-108">
                09 83 49 01 81 • contact@zilleniumalternance.fr
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-lavande p-6 text-center text-primary-dark shrink-0 font-bold" data-id="element-109">
        <p data-id="element-110">
          Certification visée : TP - Conseiller de vente, fiche RNCP37098
          enregistrée auprès de France Compétences.
        </p>
        <p className="text-xs font-normal text-primary-dark/60 mt-2" data-id="element-111">
          Version 2, septembre 2025
        </p>
      </div>
    </div>;
}
export function FicheBTSPanel() {
  return <div className="bg-white shadow-2xl overflow-hidden flex flex-col" data-id="element-112">
      <div className="bg-primary-dark p-8 flex justify-between items-center shrink-0" data-id="element-113">
        <div data-id="element-114">
          <p className="text-brand-orange font-bold text-sm tracking-wider mb-1" data-id="element-115">
            FICHE FORMATION
          </p>
          <h2 className="text-3xl font-heading font-extrabold text-white" data-id="element-116">
            BTS NDRC
          </h2>
        </div>
        <div className="bg-brand-orange text-white font-bold px-6 py-2" data-id="element-117">
          Niveau 5 • RNCP38368 • 2026–2028
        </div>
      </div>
      <div className="flex-1 flex p-8 gap-12" data-id="element-118">
        <div className="w-[45%] flex flex-col" data-id="element-119">
          <h3 className="text-2xl font-heading font-extrabold text-primary-dark mb-4 leading-tight" data-id="element-120">
            DÉVELOPPER LA RELATION CLIENT ET LA PERFORMANCE COMMERCIALE
          </h3>
          <p className="text-primary-dark font-bold mb-6" data-id="element-121">
            Le BTS Négociation et digitalisation de la relation client forme des
            commerciaux généralistes capables d'agir en présentiel, à distance,
            en e-relation et au sein de réseaux.
          </p>

          <h4 className="text-brand-orange font-bold mb-2" data-id="element-122">PUBLIC VISÉ</h4>
          <p className="text-primary-dark text-sm mb-6" data-id="element-123">
            Candidats souhaitant exercer dans la prospection, la négociation, la
            gestion de clientèle, la vente à distance, l'e-commerce ou
            l'animation commerciale.
          </p>

          <h4 className="text-brand-orange font-bold mb-2" data-id="element-124">PRÉREQUIS</h4>
          <p className="text-primary-dark text-sm mb-6" data-id="element-125">
            Niveau 4 validé ou parcours compatible, expression écrite et orale
            solide, bases numériques, motivation commerciale et projet validé
            après positionnement.
          </p>

          <div className="bg-primary-dark text-white p-6 mt-auto" data-id="element-126">
            <h4 className="text-brand-orange font-bold mb-2" data-id="element-127">
              OBJECTIFS PÉDAGOGIQUES MESURABLES
            </h4>
            <p className="text-sm font-medium" data-id="element-128">
              À l'issue du parcours, l'apprenant sera capable de cibler et
              prospecter une clientèle, négocier une solution, organiser une
              action commerciale, exploiter l'information client, animer la
              relation digitale, développer l'e-commerce et contribuer à un
              réseau de distributeurs, partenaires ou vente directe.
            </p>
          </div>
        </div>
        <div className="w-[55%] flex flex-col gap-4 text-sm" data-id="element-129">
          <div className="flex gap-8 border-b border-primary/20 pb-4" data-id="element-130">
            <div className="w-1/2" data-id="element-131">
              <h4 className="font-bold text-primary-dark mb-1" data-id="element-132">DURÉE</h4>
              <p className="text-primary-dark" data-id="element-133">
                Parcours en alternance sur 2 ans, session 2026–2028.
              </p>
            </div>
            <div className="w-1/2" data-id="element-134">
              <h4 className="font-bold text-primary-dark mb-1" data-id="element-135">RYTHME</h4>
              <p className="text-primary-dark" data-id="element-136">
                3 jours en entreprise et 2 jour en centre de formation. (Lundi,
                Mardi)
              </p>
            </div>
          </div>
          <div className="flex gap-8 border-b border-primary/20 pb-4" data-id="element-137">
            <div className="w-1/2" data-id="element-138">
              <h4 className="font-bold text-primary-dark mb-1" data-id="element-139">RENTRÉE</h4>
              <p className="text-primary-dark" data-id="element-140">
                25 septembre 2026, sous réserve de places disponibles.
              </p>
            </div>
            <div className="w-1/2" data-id="element-141">
              <h4 className="font-bold text-primary-dark mb-1" data-id="element-142">ACCÈS</h4>
              <p className="text-primary-dark" data-id="element-143">
                Candidature, entretien, positionnement, validation du projet et
                contrat d'apprentissage.
              </p>
            </div>
          </div>
          <div className="flex gap-8 border-b border-primary/20 pb-4" data-id="element-144">
            <div className="w-1/2" data-id="element-145">
              <h4 className="font-bold text-primary-dark mb-1" data-id="element-146">
                DÉLAI D'ACCÈS
              </h4>
              <p className="text-primary-dark" data-id="element-147">
                Selon calendrier, date de candidature, places disponibles et
                contractualisation.
              </p>
            </div>
            <div className="w-1/2" data-id="element-148">
              <h4 className="font-bold text-primary-dark mb-1" data-id="element-149">
                TARIF APPRENTI
              </h4>
              <p className="text-primary-dark" data-id="element-150">
                0 € pour l'apprenti sous contrat ; financement selon prise en
                charge OPCO.
              </p>
            </div>
          </div>
          <div className="border-b border-brand-orange pb-4" data-id="element-151">
            <h4 className="font-bold text-primary-dark mb-1" data-id="element-152">
              MÉTHODES MOBILISÉES
            </h4>
            <p className="text-primary-dark" data-id="element-153">
              Apports structurés, études de cas, entraînements de négociation,
              CRM et outils digitaux, projects commerciaux, e-commerce, jeux de
              rôle et suivi individualisé.
            </p>
          </div>
          <div className="flex gap-8 border-b border-primary/20 pb-4" data-id="element-154">
            <div className="w-1/2" data-id="element-155">
              <h4 className="font-bold text-primary-dark mb-1" data-id="element-156">
                ÉVALUATIONS EN FORMATION
              </h4>
              <p className="text-primary-dark" data-id="element-157">
                Contrôles, dossiers, oraux, situations professionnelles,
                productions digitales et bilans d'acquisition.
              </p>
            </div>
            <div className="w-1/2" data-id="element-158">
              <h4 className="font-bold text-primary-dark mb-1" data-id="element-159">
                CERTIFICATION
              </h4>
              <p className="text-primary-dark" data-id="element-160">
                Épreuves selon règlement du BTS : CCF lorsque l'habilitation le
                permet ou forme ponctuelle.
              </p>
            </div>
          </div>
          <div className="flex gap-8" data-id="element-161">
            <div className="w-1/2" data-id="element-162">
              <h4 className="font-bold text-primary-dark mb-1" data-id="element-163">
                ACCESSIBILITÉ PSH
              </h4>
              <p className="text-primary-dark" data-id="element-164">
                Étude individualisée des besoins. Référent handicap :
                samir@zilleniumalternance.fr.
              </p>
            </div>
            <div className="w-1/2" data-id="element-165">
              <h4 className="font-bold text-primary-dark mb-1" data-id="element-166">CONTACT</h4>
              <p className="text-primary-dark" data-id="element-167">
                09 83 49 01 81 • contact@zilleniumalternance.fr
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-lavande p-6 text-center text-primary-dark shrink-0 font-bold" data-id="element-168">
        <p data-id="element-169">
          Certification visée : BTS - Négociation et digitalisation de la
          relation client, fiche RNCP38368.
        </p>
        <p className="text-xs font-normal text-primary-dark/60 mt-2" data-id="element-170">
          Version 2, septembre 2025
        </p>
      </div>
    </div>;
}
export function CertifBTSPanel() {
  return <div className="bg-lavande shadow-2xl overflow-hidden flex flex-col" data-id="element-171">
      <div className="bg-primary-dark p-8 flex justify-between items-center shrink-0" data-id="element-172">
        <div data-id="element-173">
          <p className="text-brand-orange font-bold text-sm tracking-wider mb-1" data-id="element-174">
            CERTIFICATION PROFESSIONNELLE
          </p>
          <h2 className="text-3xl font-heading font-extrabold text-white" data-id="element-175">
            BTS NDRC
          </h2>
        </div>
        <div className="bg-brand-orange text-white font-bold px-6 py-2" data-id="element-176">
          RNCP38368 • France Compétences
        </div>
      </div>
      <div className="flex-1 flex p-8 gap-12 bg-white m-8 mt-0 shadow-sm" data-id="element-177">
        <div className="w-[35%] flex flex-col" data-id="element-178">
          <h3 className="text-2xl font-heading font-extrabold text-primary-dark mb-6 bg-lavande p-2" data-id="element-179">
            REPÈRES RNCP
          </h3>
          <div className="flex flex-col gap-3 text-sm mb-6" data-id="element-180">
            <div className="border-b border-primary/20 pb-2" data-id="element-181">
              <h4 className="font-bold text-primary-dark" data-id="element-182">INTITULÉ EXACT</h4>
              <p className="text-primary-dark" data-id="element-183">
                BTS - Négociation et digitalisation de la relation client.
              </p>
            </div>
            <div className="border-b border-primary/20 pb-2" data-id="element-184">
              <h4 className="font-bold text-primary-dark" data-id="element-185">NIVEAU / DOMAINE</h4>
              <p className="text-primary-dark" data-id="element-186">
                Niveau 5 • NSF 312 Commerce, vente • Relation client et force de
                vente.
              </p>
            </div>
            <div className="border-b border-primary/20 pb-2" data-id="element-187">
              <h4 className="font-bold text-primary-dark" data-id="element-188">CERTIFICATEUR</h4>
              <p className="text-primary-dark" data-id="element-189">
                Ministère de l'Enseignement Supérieur et de la Recherche.
              </p>
            </div>
            <div className="border-b border-primary/20 pb-2" data-id="element-190">
              <h4 className="font-bold text-primary-dark" data-id="element-191">ENREGISTREMENT</h4>
              <p className="text-primary-dark" data-id="element-192">
                Début des parcours : 01/01/2024 • Échéance : 31/12/2028.
              </p>
            </div>
            <div className="border-b border-primary/20 pb-2" data-id="element-193">
              <h4 className="font-bold text-primary-dark" data-id="element-194">
                DERNIÈRE DÉLIVRANCE
              </h4>
              <p className="text-primary-dark" data-id="element-195">
                Dernière délivrance possible mentionnée : 31/12/2031.
              </p>
            </div>
            <div data-id="element-196">
              <h4 className="font-bold text-primary-dark" data-id="element-197">LIEN OFFICIEL</h4>
              <p className="text-primary-dark" data-id="element-198">
                francecompetences.fr/recherche/rncp/38368/
              </p>
            </div>
          </div>
          <div className="bg-primary-dark text-white p-4 mb-4" data-id="element-199">
            <div className="text-2xl font-extrabold text-brand-orange mb-1" data-id="element-200">
              2027
            </div>
            <div className="font-medium text-sm" data-id="element-201">
              Session BTS 2025–2027 : examen prévu en 2027, résultat non
              disponible.
            </div>
          </div>
          <div className="bg-brand-orange text-white p-4" data-id="element-202">
            <div className="text-2xl font-extrabold mb-1" data-id="element-203">2028</div>
            <div className="font-medium text-sm" data-id="element-204">
              Session BTS 2026–2028 : examen prévu en 2028, indicateur publié
              après jury.
            </div>
          </div>
        </div>
        <div className="w-[65%] flex flex-col gap-4 text-sm pt-2" data-id="element-205">
          <h3 className="text-2xl font-heading font-extrabold text-primary-dark mb-2" data-id="element-206">
            BLOCS, ÉPREUVES ET MÉTIERS
          </h3>
          <div className="flex gap-8 border-b border-primary/20 pb-4" data-id="element-207">
            <div className="w-1/2" data-id="element-208">
              <h4 className="font-bold text-primary-dark mb-1" data-id="element-209">
                RNCP38368BC01
              </h4>
              <p className="text-primary-dark" data-id="element-210">
                Relation client et négociation-vente : prospection, négociation,
                événement commercial, information commerciale.
              </p>
            </div>
            <div className="w-1/2" data-id="element-211">
              <h4 className="font-bold text-primary-dark mb-1" data-id="element-212">
                RNCP38368BC02
              </h4>
              <p className="text-primary-dark" data-id="element-213">
                Relation client à distance et digitalisation : omnicanal,
                relation digitale, e-commerce.
              </p>
            </div>
          </div>
          <div className="flex gap-8 border-b border-primary/20 pb-4" data-id="element-214">
            <div className="w-1/2" data-id="element-215">
              <h4 className="font-bold text-primary-dark mb-1" data-id="element-216">
                RNCP38368BC03
              </h4>
              <p className="text-primary-dark" data-id="element-217">
                Relation client et animation de réseaux : distributeurs,
                partenaires, vente directe.
              </p>
            </div>
            <div className="w-1/2" data-id="element-218">
              <h4 className="font-bold text-primary-dark mb-1" data-id="element-219">ÉVALUATIONS</h4>
              <p className="text-primary-dark" data-id="element-220">
                BC01 et BC03 : CCF 2 situations si habilité ou ponctuelle orale
                ; BC02 : écrite et pratique.
              </p>
            </div>
          </div>
          <div className="flex gap-8 border-b border-brand-orange pb-4" data-id="element-221">
            <div className="w-1/2" data-id="element-222">
              <h4 className="font-bold text-primary-dark mb-1" data-id="element-223">
                CAPITALISATION
              </h4>
              <p className="text-primary-dark" data-id="element-224">
                Chaque unité correspond à un bloc ; dispense possible des
                épreuves déjà validées selon règlement du diplôme.
              </p>
            </div>
            <div className="w-1/2" data-id="element-225">
              <h4 className="font-bold text-primary-dark mb-1" data-id="element-226">SECTEURS</h4>
              <p className="text-primary-dark" data-id="element-227">
                Toute organisation commerciale, industrielle, artisanale,
                associative ou publique avec démarche commerciale.
              </p>
            </div>
          </div>
          <div data-id="element-228">
            <h4 className="font-bold text-primary-dark mb-1" data-id="element-229">
              DÉBOUCHÉS OFFICIELS
            </h4>
            <p className="text-primary-dark" data-id="element-230">
              Commercial terrain, négociateur, conseiller commercial, chargé de
              clientèle, technico-commercial, téléconseiller, commercial
              e-commerce, chef de secteur, animateur réseau. Codes ROME : D1401,
              D1406, D1501, M1703, M1704.
            </p>
          </div>
        </div>
      </div>
      <div className="bg-lavande/50 p-6 text-center text-primary-dark shrink-0 font-bold" data-id="element-231">
        <p data-id="element-232">
          Les informations de certification sont issues de la fiche France
          Compétences RNCP38368 consultable publiquement.
        </p>
        <p className="text-xs font-normal text-primary-dark/60 mt-2" data-id="element-233">
          Version 2, septembre 2025
        </p>
      </div>
    </div>;
}
export function CertifTPPanel() {
  return <div className="bg-lavande shadow-2xl overflow-hidden flex flex-col" data-id="element-234">
      <div className="bg-primary-dark p-8 flex justify-between items-center shrink-0" data-id="element-235">
        <div data-id="element-236">
          <p className="text-brand-orange font-bold text-sm tracking-wider mb-1" data-id="element-237">
            CERTIFICATION PROFESSIONNELLE
          </p>
          <h2 className="text-3xl font-heading font-extrabold text-white" data-id="element-238">
            TP CONSEILLER DE VENTE
          </h2>
        </div>
        <div className="bg-brand-orange text-white font-bold px-6 py-2" data-id="element-239">
          RNCP37098 • France Compétences
        </div>
      </div>
      <div className="flex-1 flex p-8 gap-12 bg-white m-8 mt-0 shadow-sm" data-id="element-240">
        <div className="w-[35%] flex flex-col" data-id="element-241">
          <h3 className="text-2xl font-heading font-extrabold text-primary-dark mb-6 bg-lavande p-2" data-id="element-242">
            REPÈRES RNCP
          </h3>
          <div className="flex flex-col gap-3 text-sm mb-6" data-id="element-243">
            <div className="border-b border-primary/20 pb-2" data-id="element-244">
              <h4 className="font-bold text-primary-dark" data-id="element-245">INTITULÉ EXACT</h4>
              <p className="text-primary-dark" data-id="element-246">TP - Conseiller de vente.</p>
            </div>
            <div className="border-b border-primary/20 pb-2" data-id="element-247">
              <h4 className="font-bold text-primary-dark" data-id="element-248">NIVEAU / DOMAINE</h4>
              <p className="text-primary-dark" data-id="element-249">
                Niveau 4 • NSF 312m Commerce, vente • Formacode 34502.
              </p>
            </div>
            <div className="border-b border-primary/20 pb-2" data-id="element-250">
              <h4 className="font-bold text-primary-dark" data-id="element-251">CERTIFICATEUR</h4>
              <p className="text-primary-dark" data-id="element-252">
                Ministère du Travail du Plein Emploi et de l'Insertion.
              </p>
            </div>
            <div className="border-b border-primary/20 pb-2" data-id="element-253">
              <h4 className="font-bold text-primary-dark" data-id="element-254">ENREGISTREMENT</h4>
              <p className="text-primary-dark" data-id="element-255">
                Début des parcours : 25/01/2023 • Échéance : 25/01/2028.
              </p>
            </div>
            <div data-id="element-256">
              <h4 className="font-bold text-primary-dark" data-id="element-257">LIEN OFFICIEL</h4>
              <p className="text-primary-dark" data-id="element-258">
                francecompetences.fr/recherche/rncp/37098/
              </p>
            </div>
          </div>
          <div className="bg-brand-orange text-white p-4 mb-4" data-id="element-259">
            <div className="text-3xl font-extrabold mb-1" data-id="element-260">100 %</div>
            <div className="font-bold text-sm" data-id="element-261">
              Taux de réussite constaté pour la session TP 2024–2025.
            </div>
          </div>
          <div className="bg-primary-dark text-white p-4" data-id="element-262">
            <div className="text-2xl font-extrabold mb-1" data-id="element-263">À venir</div>
            <div className="font-medium text-sm" data-id="element-264">
              Session TP 2026–2027 : examen non encore passé, indicateur publié
              après jury.
            </div>
          </div>
        </div>
        <div className="w-[65%] flex flex-col gap-4 text-sm pt-2" data-id="element-265">
          <h3 className="text-2xl font-heading font-extrabold text-primary-dark mb-2" data-id="element-266">
            BLOCS, ÉPREUVES ET MÉTIERS
          </h3>
          <div className="flex gap-8 border-b border-primary/20 pb-4" data-id="element-267">
            <div className="w-1/2" data-id="element-268">
              <h4 className="font-bold text-primary-dark mb-1" data-id="element-269">
                RNCP37098BC01
              </h4>
              <p className="text-primary-dark" data-id="element-270">
                Efficacité commerciale omnicanale : veille, flux marchands,
                merchandising, analyse des performances et compte rendu.
              </p>
            </div>
            <div className="w-1/2" data-id="element-271">
              <h4 className="font-bold text-primary-dark mb-1" data-id="element-272">
                RNCP37098BC02
              </h4>
              <p className="text-primary-dark" data-id="element-273">
                Expérience client omnicanale : image de l'unité, entretien de
                vente, suivi des ventes, fidélisation.
              </p>
            </div>
          </div>
          <div className="flex gap-8 border-b border-primary/20 pb-4" data-id="element-274">
            <div className="w-1/2" data-id="element-275">
              <h4 className="font-bold text-primary-dark mb-1" data-id="element-276">
                ÉPREUVE GLOBALE
              </h4>
              <p className="text-primary-dark" data-id="element-277">
                3 h 55 : mise en situation 2 h, entretien technique 30 min,
                productions 1 h 10, entretien final 15 min.
              </p>
            </div>
            <div className="w-1/2" data-id="element-278">
              <h4 className="font-bold text-primary-dark mb-1" data-id="element-279">
                CAPITALISATION
              </h4>
              <p className="text-primary-dark" data-id="element-280">
                Deux certificats de compétences professionnelles capitalisables
                selon les règles du titre professionnel.
              </p>
            </div>
          </div>
          <div className="flex gap-8 border-b border-brand-orange pb-4" data-id="element-281">
            <div className="w-1/2" data-id="element-282">
              <h4 className="font-bold text-primary-dark mb-1" data-id="element-283">
                CORRESPONDANCE
              </h4>
              <p className="text-primary-dark" data-id="element-284">
                Correspondance partielle avec l'ancien RNCP13620 TP
                Vendeur(se)-conseil en magasin.
              </p>
            </div>
            <div className="w-1/2" data-id="element-285">
              <h4 className="font-bold text-primary-dark mb-1" data-id="element-286">SECTEURS</h4>
              <p className="text-primary-dark" data-id="element-287">
                GMS, surfaces spécialisées, grands magasins, boutiques,
                proximité, négoces interentreprises, gros.
              </p>
            </div>
          </div>
          <div data-id="element-288">
            <h4 className="font-bold text-primary-dark mb-1" data-id="element-289">
              DÉBOUCHÉS OFFICIELS
            </h4>
            <p className="text-primary-dark" data-id="element-290">
              Conseiller clientèle, vendeur expert, vendeur conseil, vendeur
              technique, vendeur en magasin, magasinier vendeur. Codes ROME :
              D1209, D1214, D1211, D1212, D1210.
            </p>
          </div>
        </div>
      </div>
      <div className="bg-lavande/50 p-6 text-center text-primary-dark shrink-0 font-bold" data-id="element-291">
        <p data-id="element-292">
          Les informations de certification sont issues de la fiche France
          Compétences RNCP37098 consultable publiquement.
        </p>
        <p className="text-xs font-normal text-primary-dark/60 mt-2" data-id="element-293">
          Version 2, septembre 2025
        </p>
      </div>
    </div>;
}
export function ModalitesAccessPanel() {
  return <div className="bg-lavande shadow-2xl overflow-hidden flex flex-col" data-id="element-294">
      <div className="bg-primary-dark p-8 flex justify-between items-center shrink-0" data-id="element-295">
        <div data-id="element-296">
          <p className="text-brand-orange font-bold text-sm tracking-wider mb-1" data-id="element-297">
            MODALITÉS D'ACCÈS — INFORMATIONS CANDIDATS
          </p>
          <h2 className="text-3xl font-heading font-extrabold text-white leading-tight" data-id="element-298">
            ADMISSION, ACCOMPAGNEMENT ET ACCESSIBILITÉ
          </h2>
        </div>
        <div className="bg-brand-orange text-white font-bold px-6 py-2 max-w-[180px]" data-id="element-299">
          TP Conseiller de Vente • BTS NDRC
        </div>
      </div>
      <div className="flex-1 flex p-8 gap-12" data-id="element-300">
        <div className="w-1/2 flex flex-col" data-id="element-301">
          <h3 className="text-2xl font-heading font-extrabold text-primary-dark mb-4" data-id="element-302">
            PARCOURS D'ACCÈS CANDIDAT
          </h3>
          <p className="text-primary-dark font-bold mb-6" data-id="element-303">
            L'entrée en formation suit un processus transparent permettant de
            vérifier le projet, les prérequis, les besoins d'accompagnement et
            la faisabilité de l'alternance.
          </p>
          <div className="grid grid-cols-2 gap-x-6 gap-y-5 text-sm" data-id="element-304">
            {[{
            n: '1',
            t: 'PREMIER CONTACT',
            d: 'Demande d\u2019information par téléphone, mail, formulaire, rendez-vous ou candidature directe.'
          }, {
            n: '2',
            t: 'DOSSIER CANDIDAT',
            d: 'Collecte des éléments nécessaires : identité, parcours, projet, niveau et formation visée.'
          }, {
            n: '3',
            t: 'ENTRETIEN',
            d: 'Analyse de la motivation, cohérence du projet, disponibilité et compréhension du rythme.'
          }, {
            n: '4',
            t: 'POSITIONNEMENT',
            d: 'Vérification des acquis, prérequis, besoins pédagogiques et éventuelles adaptations PSH.'
          }, {
            n: '5',
            t: 'INFORMATION COMPLÈTE',
            d: 'Remise ou présentation du programme, tarif, rythme, évaluation, accessibilité et contacts.'
          }, {
            n: '6',
            t: 'CONTRAT D\u2019ALTERNANCE',
            d: 'Accompagnement jusqu\u2019à la recherche d\u2019entreprise et la signature du contrat d\u2019apprentissage.'
          }].map(step => <div key={step.n} className="border-t-2 border-primary pt-3 flex gap-3" data-id="element-305">
                <div className="w-8 h-8 bg-brand-orange text-white font-heading font-bold flex items-center justify-center shrink-0" data-id="element-306">
                  {step.n}
                </div>
                <div data-id="element-307">
                  <h4 className="font-bold text-primary-dark mb-1" data-id="element-308">{step.t}</h4>
                  <p className="text-primary-dark" data-id="element-309">{step.d}</p>
                </div>
              </div>)}
          </div>
        </div>
        <div className="w-1/2 flex flex-col" data-id="element-310">
          <h3 className="text-2xl font-heading font-extrabold text-primary-dark mb-4" data-id="element-311">
            DÉLAIS, SUIVI ET CONTACTS
          </h3>
          <div className="flex flex-col gap-4 text-sm" data-id="element-312">
            <div className="border-t-2 border-brand-orange pt-3" data-id="element-313">
              <h4 className="font-bold text-primary-dark mb-1" data-id="element-314">
                DÉLAIS D'ACCÈS
              </h4>
              <p className="text-primary-dark" data-id="element-315">
                Entrée selon calendrier de rentrée, places disponibles, date de
                candidature, validation du dossier et signature du contrat
                d'apprentissage. Rentrée prévue : 25 septembre 2026.
              </p>
            </div>
            <div className="border-t border-primary/30 pt-3" data-id="element-316">
              <h4 className="font-bold text-primary-dark mb-1" data-id="element-317">
                ACCOMPAGNEMENT ALTERNANCE
              </h4>
              <p className="text-primary-dark" data-id="element-318">
                Aide à la préparation du CV, à l'entretien, à la recherche
                d'entreprise et à la mise en relation avec des structures
                d'accueil lorsque cela est possible.
              </p>
            </div>
            <div className="border-t border-primary/30 pt-3" data-id="element-319">
              <h4 className="font-bold text-primary-dark mb-1" data-id="element-320">
                ACCESSIBILITÉ HANDICAP
              </h4>
              <p className="text-primary-dark" data-id="element-321">
                Accueil des personnes en situation de handicap après étude
                individualisée des besoins, identification des compensations
                possibles et adaptation du parcours si nécessaire.
              </p>
            </div>
            <div className="bg-primary-dark text-white p-4 space-y-1" data-id="element-322">
              <p data-id="element-323">
                <span className="text-brand-orange font-bold" data-id="element-324">
                  Référent handicap :
                </span>{' '}
                samir@zilleniumalternance.fr
              </p>
              <p data-id="element-325">
                <span className="text-brand-orange font-bold" data-id="element-326">
                  Contact formation :
                </span>{' '}
                contact@zilleniumalternance.fr
              </p>
              <p data-id="element-327">
                <span className="text-brand-orange font-bold" data-id="element-328">Téléphone :</span>{' '}
                09 83 49 01 81
              </p>
            </div>
            <div className="border-t border-primary/30 pt-3" data-id="element-329">
              <h4 className="font-bold text-primary-dark mb-1" data-id="element-330">ADRESSE</h4>
              <p className="text-primary-dark" data-id="element-331">
                Zillenium Alternance — 25 rue Gabriel Cortel, 89300 Joigny. Les
                informations publiées concernent uniquement le TP Conseiller de
                Vente et le BTS NDRC.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-lavande/50 p-6 text-center text-primary-dark shrink-0 font-bold" data-id="element-332">
        <p data-id="element-333">
          Aucune inscription définitive sans information complète du candidat,
          validation du projet, vérification des prérequis et contractualisation
          de l'alternance.
        </p>
        <p className="text-xs font-normal text-primary-dark/60 mt-2" data-id="element-334">
          Version 2, septembre 2025
        </p>
      </div>
    </div>;
}